import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { REQUEST } from '../app.ssr.tokens';

/**
 * Minimal tenant service for remit2any-b2b-webapp.
 * Customizes only the desktop logo based on domain.
 * - moneytransferonline.remitcircle.com, dev.moneytransferonline.remitcircle.com → moneytransferonline-logo.png
 * - localhost, dev.remitcircle.com, remitcircle.com, www.remitcircle.com → remitcircle_logo.svg
 */
@Injectable({
  providedIn: 'root',
})
export class TenantService {
  private readonly MONEYTRANSFERONLINE_DOMAINS = [
    'moneytransferonline.remitcircle.com',
    'dev.moneytransferonline.remitcircle.com',
  ];
  private readonly DEFAULT_LOGO = '/assets/images/svgs/remitcircle_logo.svg';
  private readonly MONEYTRANSFERONLINE_LOGO =
    '/assets/images/svgs/moneytransferonline-logo.png';

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    @Optional()
    @Inject(REQUEST)
    private request?: { headers?: { host?: string } },
  ) {}

  getDesktopLogo(): string {
    const hostname = this.resolveHostname();
    return this.MONEYTRANSFERONLINE_DOMAINS.includes(hostname)
      ? this.MONEYTRANSFERONLINE_LOGO
      : this.DEFAULT_LOGO;
  }

  private resolveHostname(): string {
    if (isPlatformBrowser(this.platformId)) {
      return window.location.hostname;
    }

    const hostHeader = this.request?.headers?.host ?? '';
    return hostHeader.split(':')[0].toLowerCase();
  }
}
